var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 20,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 20,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 60,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 60,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 100,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 100,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 7.5,
    stroke: "#1e293b",
    strokeOpacity: 0.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.70039ed7ff2c47271ab20f903dbc9452.svg";
export { ForwardRef as ReactComponent };